import { render, staticRenderFns } from "./contactStore.vue?vue&type=template&id=426b24f4&scoped=true"
import script from "./contactStore.vue?vue&type=script&lang=js"
export * from "./contactStore.vue?vue&type=script&lang=js"
import style0 from "./contactStore.vue?vue&type=style&index=0&id=426b24f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b24f4",
  null
  
)

export default component.exports